export class ColumnFilter {
    field: string;
    values: any[];
}
